module.exports = __webpack_public_path__ + "203f49bdd7d2285f925986104a3be43d.png";